import { Tip1 as o } from "../tips/Tip1.js";
import { Tip2 as i } from "../tips/Tip2.js";
import { Tip3 as a } from "../tips/Tip3.js";
import { Tip4 as e } from "../tips/Tip4.js";
import { Tip5 as s } from "../tips/Tip5.js";
const n = 5, u = [
  {
    svg: o,
    isIllustration: !1,
    tip: "O site e aplicativo vai ficando com a sua cara conforme você vai comprando, assim você tem uma experiência de acordo com seu padrão de compra"
  },
  {
    svg: i,
    isIllustration: !0,
    tip: "Veja produtos que você comprou anteriormente e adicione eles ao seu carrinho, fazendo suas compras com mais rapidez"
  },
  {
    svg: a,
    isIllustration: !0,
    tip: "Você também consegue repetir um pedido adicionando ele inteiro ao seu carrinho, onde você pode aumentar ou diminuir a quantidade dos produtos"
  },
  {
    svg: e,
    isIllustration: !0,
    tip: "Você terá acesso aos corredores que você mais compra logo na tela inicial, assim você consegue conferir melhor a variedade dos produtos que você mais leva"
  },
  {
    svg: s,
    isIllustration: !1,
    tip: "Siga nossas redes sociais! Estamos sempre melhorando sua experiencia em nossas Lojas, Site e Aplicativo!"
  }
];
export {
  u as TIPS,
  n as TIPS_LENGTH
};
